module.exports = __webpack_public_path__ + "static/work13-27999321fa484071212375112b2d0541.jpg";